import ScrollDown from './ScrollDown';
import RGBGlitch from './RGBGlitch';
import ViolenceLoop from './ViolenceLoop';
import StoneFloating from './StoneFloating';
import FlowerAtach from './FlowerAtach';
import FloweFall from './FlowerFall';
import LoaderDate from './LoaderDate';
import FlowerFloating from './FlowerFloating';
import FilmGlitch from './FilmGlitch';
import Loader from './Loader';
import CoordsEnter from './CoordsEnter';
import TextEnter from './TextEnter';

const animations = new Map();
animations.set('scroll-down', ScrollDown);
animations.set('rgb-glitch', RGBGlitch);
animations.set('violence-loop', ViolenceLoop);
animations.set('stone-floating', StoneFloating);
animations.set('flower-atach', FlowerAtach);
animations.set('flower-fall', FloweFall);
animations.set('loader-date', LoaderDate);
animations.set('flower-floating', FlowerFloating);
animations.set('film-glitch', FilmGlitch);
animations.set('loader', Loader);
animations.set('coords-enter', CoordsEnter);
animations.set('text-enter', TextEnter);

export default animations;
